// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { navigationModeMenuStyles } from "@vanmeter/Overrides/Components/NavigationModeMenu";
import { fontConfig } from "@vanmeter/XDL/constants";
import { color } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

navigationModeMenuStyles.currencyWrapper = {
    css: css`
        margin: 0 12px 12px;
        padding-bottom: 12px;
        border-bottom: 1px solid ${color("common.border")};
    `,
};

navigationModeMenuStyles.toggleInput = {
    css: css`
        justify-content: flex-start;
        gap: 12px;
    `,
    typographyProps: {
        ...fontConfig.xSmallSingleLine,
        weight: fontConfig.weight.bold,
    },
};
